export default __webpack_public_path__ + "static/media/pro-sin-1.82722d1a.png";